/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import InputFieldComponent from "../../../shared/components/forms/input-field/input-field";
import { PaidProductDetails } from "../../../shared/interfaces/model/tenant.interface";
import { motion } from "framer-motion";
import { ProductMemberDetails2 } from "./ProductMemberDetails2";
import InputMultiSelectComponent from "../../../shared/components/forms/multi-select/multi-select-input";
import Button2 from "../../../shared/components/button/Button2";
import { Link } from "react-router-dom";
import { User } from "../../../shared/interfaces/model/user.interface";
import { useDispatch } from "react-redux";
import * as actionDeatilTenant from "../../../store/tenant/action";
import { updateTenantObj } from "../../../shared/interfaces/components/detailsTenant.interface";
import Card from "../../card/pages/card";
import {
  AtSign,
  Boxes,
  Building2,
  Calendar,
  ChevronDown,
  ChevronRight,
  Edit3,
  HighlighterIcon,
  LucideIcon,
  Mail,
  Package,
  TicketCheckIcon,
  UserPlus,
  X,
} from "lucide-react";
import { getOrganizationBaiscFields } from "../../ProductList/components/common";
import InviteMemberCard from "./InviteMemberCard";
import { useSelector } from "react-redux";
import Loader from "../../../shared/components/loader/Loader";

interface NotTenantUserProps {
  tenant: any;
  fields: {
    name: string;
    id: string;
    Icon: LucideIcon;
  }[];
  userList: User[];
  products: any;
  tenId: string;
  productsChange: (data: any) => void;
  product: any;
  productString: string[];
  updateTenantRow: (updateTenantParam: updateTenantObj) => void;
  disable: boolean;
}

interface FormData {
  organizationName: string;
  organizationEmail: string;
  companyName?: string;
  VAT?: string;
  destinationCode?: string;
  pec?: string;
  name?: string;
  surname?: string;
  email?: string;
  city?: string;
  province?: string;
  dateOfBirth?: string;
  fiscalCode?: string;
  address?: string;
  phoneNumber?: string;
}

const NotTenantUser = ({
  disable,
  tenant,
  fields,
  userList,
  products,
  tenId,
  productsChange,
  product,
  productString,
  updateTenantRow,
}: NotTenantUserProps) => {
  const [activeTab, setActiveTab] = useState(0);
  const [disabled, setDisabled] = useState(disable);
  const [loading, setLoading] = useState(false);
  const { detailsTenantIsOk, isUserListOk } = useSelector((state: any) => ({
    detailsTenantIsOk: state.tenantsReducer.detailsTenantIsOk,
    isUserListOk: state.tenantUserListReducer.isTenantsUserListOk,
  }));
  const dispatch = useDispatch();
  const handleToggle = (index: number) => {
    setActiveTab((prev) => (prev === index ? -1 : index));
  };
  const [formData, setFormData] = useState<FormData>({
    organizationName: "",
    organizationEmail: "",
    companyName: "",
    VAT: "",
    destinationCode: "",
    pec: "",
    name: "",
    surname: "",
    email: "",
    city: "",
    province: "",
    dateOfBirth: "",
    fiscalCode: "",
    address: "",
    phoneNumber: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    setFormData({
      organizationName: tenant?.organizationName || "",
      organizationEmail: tenant?.organizationEmail || "",
      companyName: tenant?.companyName || "",
      VAT: tenant?.VAT || "",
      destinationCode: tenant?.destinationCode || "",
      pec: tenant?.pec || "",
      name: tenant?.userData?.name || "",
      surname: tenant?.userData?.surname || "",
      email: tenant?.userData?.email || "",
      city: tenant?.userData?.city || "",
      province: tenant?.userData?.province || "",
      dateOfBirth: tenant?.userData?.dateOfBirth || "",
      fiscalCode: tenant?.userData?.fiscalCode || "",
      address: tenant?.userData?.address || "",
      phoneNumber: tenant?.userData?.phoneNumber || "",
    });
  }, [tenant]);

  const getDetailTenant = (tenaId: string | undefined) => {
    setFormData({
      organizationName: tenant?.organizationName || "",
      organizationEmail: tenant?.organizationEmail || "",
      companyName: tenant?.companyName || "",
      VAT: tenant?.userData?.VAT || "",
      destinationCode: tenant?.destinationCode || "",
      pec: tenant?.userData?.pec || "",
      name: tenant?.userData?.name || "",
      surname: tenant?.userData?.surname || "",
      email: tenant?.userData?.email || "",
      city: tenant?.userData?.city || "",
      province: tenant?.userData?.province || "",
      dateOfBirth: tenant?.userData?.dateOfBirth || "",
      fiscalCode: tenant?.userData?.fiscalCode || "",
      address: tenant?.userData?.address || "",
      phoneNumber: tenant?.userData?.phoneNumber || "",
    });
    dispatch(actionDeatilTenant.getDetailsTenantRequest(tenaId || ""));
  };

  const fadeIn = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -30 },
    transition: { duration: 0.3 },
  };

  const slideIn = {
    initial: { x: -30, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    transition: { duration: 0.4, delay: 0.1 },
  };

  const renderOrganizationDetails = useMemo(() => {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {getOrganizationBaiscFields().map((field) => (
          <div className="space-y-3" key={field.id}>
            <label className="text-sm font-medium text-slate-600 dark:text-slate-300">
              {field.label}
            </label>
            <div className="group relative transition-all duration-300">
              <field.Icon
                className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400 
                group-focus-within:text-blue-500 transition-colors duration-200"
              />
              <input
                name={field.id}
                className={`w-full pl-10 pr-4 py-3 rounded-xl border focus:ring-sky-500 focus:border-transparent
                  transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 ${disabled ? "cursor-not-allowed border-slate-300 dark:border-slate-700" : "border-green-300 "}`}
                value={formData[field.id as keyof FormData]}
                disabled={disabled}
                type="text"
                id={field.id}
                onChange={handleInputChange}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }, [disabled, formData, handleInputChange]);

  return (
    <motion.div
      className="min-h-screen w-full flex flex-col bg-gradient-to-br from-slate-50/50 to-slate-100/50 dark:from-slate-900 dark:to-slate-800"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={fadeIn}
    >
      <Loader isLoading={!detailsTenantIsOk || !isUserListOk || loading} />
      <div className="w-full mx-auto px-4 py-8">
        <motion.div
          className="rounded-2xl bg-white/80 dark:bg-slate-800/90 backdrop-blur-sm shadow-xl border border-slate-200/50 dark:border-slate-700/50"
          variants={slideIn}
        >
          {/* Header Section */}
          <div className="p-6 border-b border-slate-200 dark:border-slate-700">
            <div className="flex items-center gap-4">
              <div className="p-3 rounded-full bg-sky-100 dark:bg-sky-900/50">
                <Building2 className="w-6 h-6 text-sky-600 dark:text-sky-400" />
              </div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-slate-900 to-slate-700 dark:from-slate-100 dark:to-slate-300 bg-clip-text text-transparent">
                {disabled ? "Organization Details" : "Modify Organization"}
              </h1>
            </div>
          </div>

          <div className="p-6 space-y-8">
            {/* Organization Info Section */}
            <motion.section
              className="grid grid-cols-1 md:grid-cols-2 gap-6"
              variants={fadeIn}
            >
              <div className="space-y-3">
                <label className="text-sm font-medium text-slate-600 dark:text-slate-300">
                  Tenant Name
                </label>
                <div className="group relative transition-all duration-300">
                  <Building2
                    className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400 
                    group-focus-within:text-sky-500 transition-colors duration-200"
                  />
                  <input
                    name="organizationName"
                    className={`w-full pl-10 pr-4 py-3 rounded-xl border  
                     transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 bg-white ${disabled ? "cursor-not-allowed border-slate-300 dark:border-slate-700" : "border-green-300 "}`}
                    value={formData.organizationName}
                    disabled={disabled}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="space-y-3">
                <label className="text-sm font-medium text-slate-600 dark:text-slate-300">
                  Tenant Email
                </label>
                <div className="group relative transition-all duration-300">
                  <Mail
                    className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400 
                    group-focus-within:text-blue-500 transition-colors duration-200"
                  />
                  <input
                    name="organizationEmail"
                    className={`w-full pl-10 pr-4 py-3 rounded-xl border border-slate-300 dark:border-slate-700 
                      bg-gray-200 dark:bg-slate-800 focus:ring-2 focus:ring-sky-500 focus:border-transparent
                      transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 cursor-not-allowed `}
                    value={formData.organizationEmail}
                    disabled={true}
                    onChange={() => {
                      return;
                    }}
                  />
                </div>
              </div>
            </motion.section>

            {/* Products Section */}
            <motion.section variants={fadeIn} className="space-y-6">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-sky-100 dark:bg-sky-900/50">
                  <Package className="w-5 h-5 text-sky-600 dark:text-sky-400" />
                </div>
                <h2 className="text-lg font-bold text-slate-800 dark:text-white">
                  Products
                </h2>
              </div>

              <div className="bg-slate-50/50 dark:bg-slate-700/50 backdrop-blur-sm rounded-xl p-6 border border-slate-200/50 dark:border-slate-600/50">
                <div className="grid gap-4">
                  {tenant?.testProducts?.map(
                    (pro: PaidProductDetails, index: number) => {
                      const isValid =
                        pro.expireDate && new Date(pro.expireDate) > new Date();
                      if (!isValid) return null;

                      return (
                        <motion.div
                          key={pro.productAppCode}
                          className="space-y-4"
                        >
                          <motion.button
                            className={`w-full flex items-center justify-between p-4 rounded-xl border transition-all duration-200
                            ${
                              activeTab === index
                                ? "bg-sky-50 dark:bg-sky-900/30 border-sky-500 shadow-sm"
                                : "border-slate-200 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-700/50"
                            }`}
                            onClick={() => handleToggle(index)}
                            whileHover={{ scale: 1.01 }}
                            whileTap={{ scale: 0.99 }}
                          >
                            <span className="font-medium text-slate-700 dark:text-slate-200">
                              {pro.productAppName}
                            </span>
                            {activeTab === index ? (
                              <ChevronDown className="w-4 h-4" />
                            ) : (
                              <ChevronRight className="w-4 h-4" />
                            )}
                          </motion.button>

                          {activeTab === index && (
                            <motion.div
                              initial={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: "auto" }}
                              exit={{ opacity: 0, height: 0 }}
                              transition={{ duration: 0.3 }}
                              className="border rounded-xl border-sky-500 p-6 bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm"
                            >
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {fields.map((field) => (
                                  <div key={field.id} className="space-y-2">
                                    <label className="text-sm font-medium text-slate-600 dark:text-slate-300">
                                      {field.name}
                                    </label>
                                    <div className="relative">
                                      <field.Icon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400" />
                                      <input
                                        className={`w-full pl-10 pr-4 py-3 rounded-xl border border-slate-300 dark:border-slate-700 
                       dark:bg-slate-800 focus:ring-2 focus:ring-sky-500 focus:border-transparent
                      transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 cursor-not-allowed bg-gray-200`}
                                        value={(
                                          pro[
                                            field.id as keyof Omit<
                                              PaidProductDetails,
                                              "invoices"
                                            >
                                          ] ?? ""
                                        ).toString()}
                                        disabled
                                        type="text"
                                        id={field.id}
                                      />
                                    </div>
                                  </div>
                                ))}
                              </div>

                              {tenant && userList && (
                                <div className="mt-6">
                                  <ProductMemberDetails2
                                    tenant={tenant}
                                    currentProduct={pro}
                                    userList={userList}
                                  />
                                </div>
                              )}
                            </motion.div>
                          )}
                        </motion.div>
                      );
                    }
                  )}
                </div>
              </div>
            </motion.section>
            {/* Invite Member Section */}
            <motion.div variants={fadeIn} className="space-y-6">
              <div className="row">
                {userList && isUserListOk && (
                  <div className="col-xs-12 col-md-12 col-sm-12 detailsTenant--users">
                    {tenant.testProducts?.some(
                      (product: any) => product.tier === "Enterprise"
                    ) && (
                      <>
                        <div className="flex items-center gap-3 mb-3">
                          <div className="p-2 rounded-lg bg-sky-100 dark:bg-sky-900/50">
                            <UserPlus className="w-6 h-6 text-sky-600 dark:text-sky-400" />
                          </div>
                          <h2 className="text-lg font-bold text-slate-800 dark:text-white ">
                            Invite Member
                          </h2>
                        </div>
                        <InviteMemberCard
                          id="usersCard"
                          tenantDocId={tenant.id}
                          tenantProducts={tenant.product}
                          displayName="Members"
                          testProducts={tenant.testProducts}
                          userList={[...userList]
                            .filter(
                              (user: User) =>
                                user.email === tenant.organizationEmail
                            )
                            .concat(
                              [...userList]
                                .filter(
                                  (user: User) =>
                                    user.email !== tenant.organizationEmail
                                )
                                .sort((a, b) => (a.email > b.email ? 1 : -1))
                            )}
                          organizationEmail={tenant.organizationEmail}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>
            </motion.div>

            {/* Organization Details Section */}
            <motion.section variants={fadeIn} className="space-y-6 ">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-sky-100 dark:bg-sky-900/50">
                  <Building2 className="w-6 h-6 text-sky-600 dark:text-sky-400" />
                </div>
                <h2 className="text-lg font-bold text-slate-800 dark:text-white">
                  Tenant Detail
                </h2>
              </div>
              <div
                className={`border border-slate-300 dark:border-slate-700 rounded-xl p-6 bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm ${!disabled ? "border-green-300" : ""}`}
              >
                {renderOrganizationDetails}

                {/* Action Buttons */}
                <motion.div
                  className="flex flex-wrap gap-4 justify-end pt-6"
                  variants={fadeIn}
                >
                  {disabled ? (
                    <>
                      <button
                        onClick={() => setDisabled(false)}
                        className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-sky-600 to-sky-700 
                            text-white rounded-xl hover:from-sky-700 hover:to-sky-800 transition-all duration-200
                            shadow-lg shadow-sky-500/20 hover:shadow-sky-500/30"
                      >
                        <Edit3 className="w-4 h-4" />
                        Edit Tenant
                      </button>
                      <Link to="/private/tenantlist">
                        <button
                          className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 
                            text-white rounded-xl hover:from-red-700 hover:to-red-800 transition-all duration-200
                            shadow-lg shadow-red-500/20 hover:shadow-red-500/30"
                        >
                          Back
                        </button>
                      </Link>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => {
                          setLoading(true);
                          if (tenId) {
                            const upTenant = {
                              id: tenant.id,
                              newOrgName: formData.organizationName,
                              newOrgEmail: formData.organizationEmail,
                              newProduct: productString,
                              newCompanyName: formData.companyName,
                              newVAT: formData.VAT,
                              newDestinationCode: formData.destinationCode,
                              newPec: formData.pec,
                            };
                            updateTenantRow(upTenant);
                          }
                          setDisabled(!disabled);
                          setTimeout(() => {
                            setLoading(false);
                          }, 4000);
                        }}
                        className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 
                            text-white rounded-xl hover:from-green-700 hover:to-green-800 transition-all duration-200
                            shadow-lg shadow-green-500/20 hover:shadow-green-500/30"
                      >
                        Save
                      </button>
                      <button
                        onClick={() => {
                          getDetailTenant(tenId);
                          setDisabled(!disabled);
                        }}
                        className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 
                            text-white rounded-xl hover:from-red-700 hover:to-red-800 transition-all duration-200
                            shadow-lg shadow-red-500/20 hover:shadow-red-500/30"
                      >
                        <X className="w-4 h-4" />
                        Cancel
                      </button>
                    </>
                  )}
                </motion.div>
              </div>
            </motion.section>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default NotTenantUser;
